import { SearchBox } from "./search-box.js";
import { styles } from "./search-box.styles.js";
import { template } from "./search-box.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-search-box>
 */
export const definition = SearchBox.compose({
    name: `${DesignSystem.prefix}-search-box`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=search-box.definition.js.map